/**
 * 从父级 keep-alive 缓存中移除当前组件实例（下次进入会重新创建）。
 * @param {import('vue').default} vm
 */
export function destroyKeepAliveCache(vm) {
    if (!vm || !vm.$vnode) return

    let parentVnode = vm.$vnode.parent
    while (parentVnode && parentVnode.tag !== 'keep-alive') {
        parentVnode = parentVnode.parent
    }
    if (!parentVnode || !parentVnode.componentInstance) return

    const { cache, keys } = parentVnode.componentInstance
    const vnode = vm.$vnode
    const key = vnode.key == null
        ? `${vnode.componentOptions.Ctor.cid}${vnode.componentOptions.tag ? `::${vnode.componentOptions.tag}` : ''}`
        : vnode.key

    if (!cache[key]) return
    vm.$destroy()
    delete cache[key]
    const index = keys.indexOf(key)
    if (index > -1) {
        keys.splice(index, 1)
    }
}
